import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dateFormat, SortField, dateAdd } from "../../utils/helper";
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
  name: 'logRecord',
  data: function data() {
    return {
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      provinceArr: [],
      tableHeight: window.innerHeight * 0.75,
      totalWeight: '',
      frequencyArr: [],
      balanceArr: [],
      logRecords: [],
      multipleSelection: [],
      query: {
        startDate: ''
      },
      tableData: []
    };
  },
  filters: {
    formateData: function formateData(time) {
      var date = new Date(time);
      return dateFormat.formatDate(date, 'yyyy-MM-dd');
    }
  },
  created: function created() {
    var start = new Date(); //start.setTime(start.getTime() + 3600 * 1000 * 24);

    this.query.startDate = start;
    this.getData();
  },
  methods: {
    //自定义方法
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = {};
      var newData = [];

      for (var i = 0; i < data.length; i++) {
        if (data[i].indicatorName == "产量（吨）") {
          newData[i] = data[i];
        }
      }

      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '公司合计';
          return;
        }

        if (index === 1) {
          sums[index] = '产量（吨）';
          return;
        }

        var values = newData.map(function (item) {
          return Number(item[column.property]);
        });

        if (column.label != "序号" && column.label != "煤矿名称" && column.label != "指标名称") {
          if (!values.every(function (value) {
            return isNaN(value);
          })) {
            sums[index - 1] = values.reduce(function (prev, curr) {
              var value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index - 1] = sums[index - 1].toFixed(2); // 保留2位小数
          }
        }
      });
      return sums;
    },
    mergeCol: function mergeCol(id, rowIndex) {
      // 合并单元格
      // id：属性名
      // rowIndex：行索引值
      var idName = this.tableData[rowIndex][id]; // 获取当前单元格的值

      if (rowIndex > 0) {
        // 判断是不是第一行
        // eslint-disable-next-line eqeqeq
        if (this.tableData[rowIndex][id] != this.tableData[rowIndex - 1][id]) {
          // 先判断当前单元格的值是不是和上一行的值相等
          var i = rowIndex;
          var num = 0; // 定义一个变量i，用于记录行索引值并进行循环，num用于计数

          while (i < this.tableData.length) {
            // 当索引值小于table的数组长度时，循环执行
            if (this.tableData[i][id] === idName) {
              // 判断循环的单元格的值是不是和当前行的值相等
              i++; // 如果相等，则索引值加1

              num++; // 合并的num计数加1
            } else {
              i = this.tableData.length; // 如果不相等，将索引值设置为table的数组长度，跳出循环
            }
          }

          return {
            rowspan: num,
            // 最终将合并的行数返回
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            // 如果相等，则将rowspan设置为0
            colspan: 1
          };
        }
      } else {
        // 如果是第一行，则直接返回
        var _i = rowIndex;
        var _num = 0;

        while (_i < this.tableData.length) {
          // 当索引值小于table的数组长度时，循环执行
          if (this.tableData[_i][id] === idName) {
            _i++;
            _num++;
          } else {
            _i = this.tableData.length;
          }
        }

        return {
          rowspan: _num,
          colspan: 1
        };
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var _this = this;

      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      // 合并单元格
      switch (columnIndex) {
        // 将列索引作为判断值
        // 通过传递不同的列索引和需要合并的属性名，可以实现不同列的合并
        case 0:
          return this.mergeCol('index', rowIndex);

        case 1:
          return this.mergeCol('mineName', rowIndex);
      }

      this.$nextTick(function (x) {
        if (_this.$refs.table.$el) {
          var current = _this.$refs.table.$el.querySelector(".el-table__footer-wrapper").querySelector(".el-table__footer");

          var cell = current.rows[0].cells;
          cell[0].colSpan = "2";
          cell[0].rowSpan = "1";
          cell[1].rowSpan = "1";
          cell[2].rowSpan = "1";
        }

        _this.$refs['table'].doLayout();
      });
    },
    getData: function getData() {
      var _this2 = this;

      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.isAdmin = userInfo.id == 1 ? true : false;

      if (this.query.startDate == null) {
        this.$notify.warning('日期不能为空!!!');
        return;
      }

      this.query.startDate = new Date(dateFormat.formatDate(this.query.startDate, 'yyyy-MM-dd 08:00:00'));
      this.query.loginId = userInfo.loginId;
      this.query.userType = userInfo.userType;
      this.$zybhttp.post('WashingProductReport/WashingProductDailyReportData', this.query).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this2.tableData = d;
        } else {
          _this2.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this2.$notify.error('网络异常！获取列表失败！');
      });
    },
    formateData: function formateData(time) {
      var date = new Date(time);
      return dateFormat.formatDate(date, 'yyyy-MM-dd');
    },
    exportlist: function exportlist() {
      var date = new Date();
      var name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
      var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });

      try {
        FileSaver.saveAs(new Blob([wbout], {
          type: 'application/octet-stream'
        }), '晋城公司洗选产品数质量日报表' + name + '.xlsx');
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
      }

      return wbout;
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};